<template>
    <div class="mx-auto w-full max-w-[1168px] pb-40 px-8 pt-6">
        <template v-if="state==='loading'">
            Loading Contract Data...
        </template>
        <template v-else-if="state ==='noContract'">
            No Contract for package! - Cannot create an AFP without a contract
        </template>
        <template v-else>
            <ui-header :title="'Create new Application for Payment'">
            </ui-header>

            <div class="pt-3">
                <div @click="mode='summary'"
                     class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                     style="min-width: 20px;cursor: pointer"
                     :class="mode==='summary'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                >Summary
                </div>
                <div @click="mode='measure'"
                     class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                     style="min-width: 20px;cursor: pointer"
                     :class="mode==='measure'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                >Measure of Works
                </div>
                <div @click="mode='materials'"
                     class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                     style="min-width: 20px;cursor: pointer"
                     :class="mode==='materials'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                >Unfixed Materials
                </div>
            </div>

            <template v-if="mode==='summary'">
                <div class="grid gap-6 grid-cols-12 pb-6 pt-2">
                    <div class="xl:col-span-6">
                        <div class="w-full mt-0 mb-1">Application Costings</div>
                        <div class="w-full border-gray-300 border rounded-lg p-0 m-0 mt-px">
                            <div
                                class="flex mt-0 px-2 border-b rounded-t-lg border-gray-200 bg-gray-50 text-sm text-gray-500 font-semibold">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Cost Element</div>
                                <div class="w-32 px-2 py-2 -ml-px text-right">Amount (£)</div>
                            </div>
                            <div
                                class="flex mt-0 px-2 text-sm text-gray-500 border-gray-200 border-b font-semibold">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Original Contract Value
                                </div>
                                <div class="w-32 px-2 py-2 -ml-px text-right" v-text="afp.originalContractValue"></div>
                            </div>
                            <div
                                class="flex mt-0 px-2 text-sm text-gray-500 border-gray-200 border-b font-semibold">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Agreed Variations</div>
                                <div class="w-32 px-2 py-2 -ml-px text-right" v-text="afp.totalVariationsValue"></div>
                            </div>
                            <div
                                class="flex mt-0 px-2 text-sm text-gray-700 border-gray-200 border-b font-semibold">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Contract Value to date
                                </div>
                                <div class="w-32 px-2 py-2 -ml-px text-right" v-text="afp.contractedWorksValue"></div>
                            </div>
                            <div
                                class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b">
                                <div class="flex-1 border-l border-gray-200 px-2 py-2 -ml-px bg-gray-50"></div>
                            </div>
                            <div
                                class="flex mt-0 px-2 text-sm text-gray-500 border-gray-200 border-b">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Measured Works</div>
                                <div class="w-32 px-2 py-2 -ml-px text-right" v-text="sumMeasuredWorks()"></div>
                            </div>
                            <div
                                class="flex mt-0 px-2 text-sm text-gray-500 border-gray-200 border-b">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Anticipated Variations
                                </div>
                                <div class="w-32 px-2 py-2 -ml-px text-right">-</div>
                            </div>
                            <div
                                class="flex mt-0 px-2 text-sm text-gray-500 border-gray-200 border-b">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Contra Charges</div>
                                <div class="w-32 px-2 py-2 -ml-px text-right">-</div>
                            </div>
                            <div
                                class="flex mt-0 px-2 text-sm text-gray-500 border-gray-200 border-b">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Dayworks</div>
                                <div class="w-32 px-2 py-2 -ml-px text-right">-</div>
                            </div>
                            <div
                                class="flex mt-0 px-2 text-sm text-gray-500 border-gray-200 border-b">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Materials On-site
                                    (unfixed)
                                </div>
                                <div class="w-32 px-2 py-2 -ml-px text-right" v-text="totalOnSiteValue"></div>
                            </div>
                            <div
                                class="flex mt-0 px-2 text-sm text-gray-500 border-gray-200 border-b">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Materials Off-site
                                    (unfixed)
                                </div>
                                <div class="w-32 px-2 py-2 -ml-px text-right" v-text="totalOffSiteValue"></div>
                            </div>
                            <div
                                class="flex mt-0 px-2 text-sm text-gray-500 border-gray-200">
                                <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Retention Held (5%)
                                </div>
                                <div class="w-32 px-2 py-2 -ml-px text-right">-</div>
                            </div>
                        </div>
                    </div>
                    <div class="pb-6 xl:col-span-6">
                        <ui-date-picker label="Application for Payment Date" name="date" v-model="afp.date"
                                        class="pb-6"
                                        placeholder="What is date for this afp report?"
                                        :error="dateError"
                                        :with-time="false"
                                        @input="dateError=''; save()"></ui-date-picker>

                        <ui-textarea autoresize label="Comments" name="comments" v-model="afp.comments"
                                     placeholder="Notes..."
                                     @input="save"></ui-textarea>
                    </div>
                </div>
            </template>
            <template v-else-if="mode==='materials'">
                <!-- Materials on Site -->
                <div class="pb-6 pt-2 ">
                    <div class="w-full mb-1">Materials On Site:</div>
                    <div class="w-full border-gray-300 border rounded-lg p-2">
                        <div
                            class="flex mt-4 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                            <div class="w-6 border-r border-gray-200 px-2 py-1"></div>
                            <div class="flex-1 border-r border-gray-200 px-2 py-1 -ml-px">Material</div>
                            <div class="w-24 border-r border-gray-200 px-2 py-1 -ml-px">UoM</div>
                            <div class="w-24 border-r border-gray-200 px-2 py-1 -ml-px">Unfixed Qty</div>
                            <div class="w-24 border-r border-gray-200 px-2 py-1 -ml-px text-right">£ Rate</div>
                            <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">£ Total</div>
                            <div class="w-8 border-gray-200 px-2 py-1"></div>
                        </div>
                        <div class="pb-4">
                            <draggable :list="afp.onSiteMaterials" draggable=".draggable" handle=".handle"
                                       :group="'onSiteMaterials'" @change="updateOnSiteMaterialPosition"
                                       :key="onSiteMaterialsKey">
                                <application-for-payment-material v-for="(material,index) in afp.onSiteMaterials"
                                                                  :key="index"
                                                                  ref="onSiteMaterials"
                                                                  :material="material"
                                                                  @removeMaterial="removeOnSiteMaterial"
                                                                  @change="updateOnSiteTotal"
                                                                  :readonly="false"
                                ></application-for-payment-material>
                            </draggable>
                            <!-- New Task Item. -->
                            <div class="flex border-b -mb-px border-gray-200" v-if="!readonly">
                                <div class="w-6 flex-shrink-0 self-center">
                                    <i class="fa fa-plus text-xs text-gray-300"></i>
                                </div>
                                <div class="flex-1 -ml-px">
                                    <input
                                        :placeholder="'Add new Material...'"
                                        class="text-sm -my-px px-2 py-1.5 border border-gray-200 shadow-none relative focus:z-10"
                                        type="text"
                                        @input="addNewOnSiteMaterial"
                                        v-model="newOnSiteMaterialItem"
                                    >
                                </div>
                                <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
                                </div>
                            </div>

                            <!-- Total Amount. -->
                            <div class="flex text-xs text-gray-500 text-right font-semibold bg-white">
                                <div class="flex-1 px-2 py-1">Total</div>
                                <div class="w-20 -ml-px px-2 py-1" v-text="totalOnSiteValue">
                                </div>
                                <div class="w-6 flex-shrink-0 ml-2"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Materials Off Site -->
                <div class="pb-6">
                    <div class="w-full mb-1">Materials Off-Site:</div>
                    <div class="w-full border-gray-300 border rounded-lg p-2">
                        <div
                            class="flex mt-4 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                            <div class="w-6 border-r border-gray-200 px-2 py-1"></div>
                            <div class="flex-1 border-r border-gray-200 px-2 py-1 -ml-px">Material</div>
                            <div class="w-24 border-r border-gray-200 px-2 py-1 -ml-px">UoM</div>
                            <div class="w-24 border-r border-gray-200 px-2 py-1 -ml-px">Unfixed Qty</div>
                            <div class="w-24 border-r border-gray-200 px-2 py-1 -ml-px text-right">£ Rate</div>
                            <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">£ Total</div>
                            <div class="w-8 border-gray-200 px-2 py-1"></div>
                        </div>
                        <div class="pb-4">
                            <draggable :list="afp.offSiteMaterials" draggable=".draggable" handle=".handle"
                                       :group="'offSiteMaterials'" @change="updateOffSiteMaterialPosition"
                                       :key="offSiteMaterialsKey">
                                <application-for-payment-material v-for="(material,index) in afp.offSiteMaterials"
                                                                  :key="index"
                                                                  ref="offSiteMaterials"
                                                                  :material="material"
                                                                  @removeMaterial="removeOffSiteMaterial"
                                                                  @change="updateOffSiteTotal"
                                                                  :readonly="false"
                                ></application-for-payment-material>
                            </draggable>
                            <!-- New Task Item. -->
                            <div class="flex border-b -mb-px border-gray-200" v-if="!readonly">
                                <div class="w-6 flex-shrink-0 self-center">
                                    <i class="fa fa-plus text-xs text-gray-300"></i>
                                </div>
                                <div class="flex-1 -ml-px">
                                    <input
                                        :placeholder="'Add new Material...'"
                                        class="text-sm -my-px px-2 py-1.5 border border-gray-200 shadow-none relative focus:z-10"
                                        type="text"
                                        @input="addNewOffSiteMaterial"
                                        v-model="newOffSiteMaterialItem"
                                    >
                                </div>
                                <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
                                </div>
                            </div>

                            <!-- Total Amount. -->
                            <div class="flex text-xs text-gray-500 text-right font-semibold bg-white">
                                <div class="flex-1 px-2 py-1">Total</div>
                                <div class="w-20 -ml-px px-2 py-1" v-text="totalOffSiteValue">
                                </div>
                                <div class="w-6 flex-shrink-0 ml-2"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="mode==='measure'">
                <div class="pt-2" :key="contractRender">
                    <div class="w-full mb-1">Measured Works</div>
                    <div class="w-full border-gray-300 border rounded-lg p-2">
                        <div
                            class="flex mt-4 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                            <div class="w-16 border-r border-gray-200 px-2 py-1">Ref</div>
                            <div class="flex-1 border-r border-gray-200 px-2 py-1">Description</div>
                            <div class="w-24 border-r border-gray-200 px-2 py-1">Quantity</div>
                            <div class="w-20 border-r border-gray-200 px-2 py-1">Item Value</div>
                            <div class="w-20 border-r border-gray-200 px-2 py-1">Complete</div>
                            <div class="w-24 border-r border-gray-200 px-2 py-1">% Apply for</div>
                            <div class="w-24 -ml-px border-gray-200 px-2 py-1">£ Apply for</div>
                        </div>
                        <application-for-payment-section v-for="section in afp.sections" :key="section.id"
                                                         :section="section"
                                                         :readonly="false"
                        ></application-for-payment-section>
                    </div>
                </div>
            </template>
            <ui-data-grid-item wide class="mt-6 flex">
                <div class="flex flex-col md:flex-row justify-end flex-wrap">
                    <ui-button-new primary @click.prevent="submit" :loading="busy" class="ml-3">Create new Application
                        for Payment
                    </ui-button-new>
                </div>
            </ui-data-grid-item>
        </template>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import UiContainer from "../../ui/UiContainer.vue";
import UiDatePicker from "../../ui/UiDatePicker.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiHeader from "../../ui/UiHeader.vue";
import UiInput from "../../ui/UiInput.vue";
import UiToggle from "../../ui/UiToggle.vue";
import {ApplicationForPayment, ContractedWorks, ProgressReport} from "@models";
import ApplicationForPaymentSection from "./ApplicationForPaymentSection.vue";
import {resolveNumericText, toCurrency, uuid} from "../../../utils";
import moment from "moment";
import * as math from "mathjs";
import ApplicationForPaymentMaterial from "./ApplicationForPaymentMaterial.vue";

export default {
    components: {
        draggable,
        ApplicationForPaymentMaterial,
        ApplicationForPaymentSection,
        UiToggle, UiInput, UiHeader, UiDataGridItem, UiDatePicker, UiButtonNew, UiContainer
    },
    props: {
        packageReference: null,
        packageName: null,
        selectedItem: null,
        selectItem: Function,
        addItem: Function,
        readonly: false,
    },
    data() {
        return {
            afp: {},
            contractRender: 0,
            busy: false,
            dateError: '',
            moment,
            state: 'loading',
            newOnSiteMaterialItem: '',
            newOffSiteMaterialItem: '',
            onSiteMaterialsKey: 0,
            offSiteMaterialsKey: 0,
            totalOnSiteValue: 0,
            totalOffSiteValue: 0,
            mode: 'summary',
        }
    },
    computed: {},
    methods: {
        save() {
            // save AS its being updated
        },
        sumMeasuredWorks() {
            let val = 0;
            this.afp.sections.forEach((section) => {
                section.tasks.forEach((task) => {
                    task.items.forEach((item) => {
                        val += resolveNumericText(item.applyingFor)
                    })
                })
            })
            return toCurrency(val);
        },
        addNewOnSiteMaterial() {
            this.afp.onSiteMaterials.push({
                name: this.newOnSiteMaterialItem,
            })
            this.newOnSiteMaterialItem = ''
            this.$nextTick(() => {
                this.$refs.onSiteMaterials.at(-1).$refs.material.$el.focus()
            })

        },
        updateOnSiteMaterialPosition() {
            this.onSiteMaterialsKey++;
        },
        updateOnSiteTotal() {
            this.totalOnSiteValue = toCurrency(this.afp.onSiteMaterials.reduce((acc, cur) => {
                return acc + resolveNumericText(cur.total)
            }, 0));
        },
        removeOnSiteMaterial(material) {
            this.afp.onSiteMaterials.splice(this.afp.onSiteMaterials.indexOf(material), 1);
            this.onSiteMaterialsKey++;
        },
        addNewOffSiteMaterial() {
            this.afp.offSiteMaterials.push({
                name: this.newOffSiteMaterialItem,
            })
            this.newOffSiteMaterialItem = ''
            this.$nextTick(() => {
                this.$refs.offSiteMaterials.at(-1).$refs.material.$el.focus()
            })

        },
        updateOffSiteMaterialPosition() {
            this.offSiteMaterialsKey++;
        },
        updateOffSiteTotal() {
            this.totalOffSiteValue = toCurrency(this.afp.offSiteMaterials.reduce((acc, cur) => {
                return acc + resolveNumericText(cur.total)
            }, 0));
        },
        removeOffSiteMaterial(material) {
            this.afp.offSiteMaterials.splice(this.afp.offSiteMaterials.indexOf(material), 1);
            this.offSiteMaterialsKey++;
        },
        async submit() {
            this.busy = true;
            this.dateTimeError = '';
            if (!this.afp.date) {
                this.dateError = 'Please select a date for this Application for Payment'
                this.busy = false;
            } else {
                this.afp.date = moment(this.afp.date).format("YYYY-MM-DD");
                if (!this.afp.id) {
                    this.afp.id = uuid()
                }
                await ApplicationForPayment.create(this.afp);
                let item = await ApplicationForPayment.find(this.afp.id);
                this.addItem(item, 0);
                this.selectItem(item);
                this.busy = false;
            }
        },
        minDate() {
            return null;
        },
    },
    async mounted() {
        let current = await ApplicationForPayment.list(this.packageReference)
        if (current.length) {
            current = await ApplicationForPayment.find(current[0].id);
        } else {
            current = false
        }
        const contract = await ContractedWorks.find(this.packageReference)
        this.afp.contractedWorksSourceId = contract.id;
        this.afp.packageReference = this.packageReference;
        this.afp.packageName = this.packageName;
        this.afp.originalContractValue = toCurrency(resolveNumericText(contract.initialContract.value));
        let sections;
        if (contract.variations.length) {
            sections = contract.variations[contract.variations.length - 1].sections
            this.afp.contractedWorksVariationNumber = contract.variations[contract.variations.length - 1].variationNumber;
            this.afp.contractedWorksValue = toCurrency(resolveNumericText(contract.variations[contract.variations.length - 1].value));
            this.afp.totalVariationsValue = toCurrency(resolveNumericText(contract.variations[contract.variations.length - 1].value) - resolveNumericText(contract.initialContract.value));
        } else if (contract.initialContract) {
            sections = contract.initialContract.sections
            this.afp.contractedWorksVariationNumber = null;
            this.afp.contractedWorksValue = toCurrency(resolveNumericText(contract.initialContract.value));
            this.afp.totalVariationsValue = toCurrency(0);
        } else {
            this.state = 'noContract'
            return;
        }
        const progress = await ProgressReport.latest(this.packageReference)

        this.afp.onSiteMaterials = current ? current.onSiteMaterials : [];
        this.afp.offSiteMaterials = current ? current.offSiteMaterials : [];

        this.afp.date = moment().format("YYYY-MM-DD");
        this.afp.sections = sections.map((section) => {
            let cSection = current ? current.sections.find((s) => s.id === section.id) : false;
            let pSection = progress ? progress.sections.find((s) => s.id === section.id) : false;
            return {
                id: section.id,
                name: section.name,
                tasks: section.tasks.map((task) => {
                    let cTask = cSection ? cSection.tasks.find((t) => t.id === task.id) : false;
                    let pTask = pSection ? pSection.tasks.find((t) => t.id === task.id) : false;
                    return {
                        id: task.id,
                        reference: task.reference,
                        name: task.name,
                        items: task.items.map((item) => {
                            let cItem = cTask ? cTask.items.find((i) => i.id === item.id) : false;
                            let pItem = pTask ? pTask.items.find((i) => i.id === item.id) : false;
                            return {
                                id: item.id,
                                reference: item.reference,
                                description: item.description,
                                quantity: item.quantity,
                                value: item.value,
                                complete: pItem ? pItem.complete : '0%',
                                applyingFor: toCurrency(math.round(resolveNumericText(item.value) * (resolveNumericText((pItem ? pItem.complete : '0%')) / 100), 2))
                            }
                        })
                    }
                })
            }
        })
        this.updateOffSiteTotal()
        this.updateOnSiteTotal()
        this.state = 'loaded'
        this.contractRender++;
    },
    beforeUpdate() {
    }
}
</script>
